module.exports = __webpack_public_path__ + "static/media/10-shop-detail.229e31c9.png";